import { Show } from 'components/atoms';
import { BeteiligungenContentRow } from 'components/profiles';
import React from 'react';
import { Referenz, ReferenzType } from 'types';
import { PersonDto } from 'types/personen';
import { useTranslation } from 'utils/hooks';

interface NetzwerkProps 
{
  person: PersonDto;
}

const Netzwerk: React.FC<NetzwerkProps> = (props) =>
{
  const { person } = props;
  const { t } = useTranslation('profiles');

  const origin: Referenz = {
    id: person.id,
    name: person.hauptPersonenDaten.fullName,
    type: ReferenzType.NatürlichePerson,
    isIndexed: false,
  };

  return (
    <>

      {/* Beteiligungen */}
      <Show when={Object.keys(person.netzwerk).length > 0}>
        <BeteiligungenContentRow
          key={`netzwerk_${person.id}`}
          title={t('profiles:personen.netzwerk.label')}
          netzwerk={person.netzwerk}
          origin={origin}
          inconsistent = {person.fbInconsistency}
          allowExtendedView={false}
          tier={person.tier}
        />
      </Show>

    </>
  );
};

export default Netzwerk;
